// extracted by mini-css-extract-plugin
export var afroGlow = "title-left-hero-module--afroGlow--S5wiG";
export var grid = "title-left-hero-module--grid--JZTD1";
export var gridText = "title-left-hero-module--gridText--Oxa-J";
export var header = "title-left-hero-module--header--YmxHC";
export var hero = "title-left-hero-module--hero--LLLtQ";
export var imageContainer = "title-left-hero-module--imageContainer--P4e2C";
export var noText = "title-left-hero-module--noText--dx5EX";
export var nuba = "title-left-hero-module--nuba--vVr0n";
export var subtitle = "title-left-hero-module--subtitle--LFEWz";
export var textClass = "title-left-hero-module--textClass--m7zMo";
export var textContainer = "title-left-hero-module--textContainer--oAM8g";
export var themedFonts = "title-left-hero-module--themedFonts---Jq4A";
export var titleDate = "title-left-hero-module--title-date--aONOR";
export var titlesContainer = "title-left-hero-module--titlesContainer--Ja0vv";
export var unformattedThemedFonts = "title-left-hero-module--unformattedThemedFonts--OB1WC";